import { render, staticRenderFns } from "./MyPo.vue?vue&type=template&id=8f54fa34&scoped=true&"
import script from "./MyPo.vue?vue&type=script&lang=js&"
export * from "./MyPo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f54fa34",
  null
  
)

export default component.exports